import { Platform } from "react-native";
import * as SecureStore from "expo-secure-store";

const TOKEN_KEY = "auth_token";

/**
 * Platform-aware auth token persistence.
 * - Web: localStorage, because expo-secure-store is not fully supported there.
 *   Note: localStorage is readable by any script on the page, so any XSS
 *   vulnerability could allow token exfiltration. Mitigate this with a strict
 *   Content Security Policy (CSP) and short-lived tokens.
 * - Native: expo-secure-store (hardware-backed on supported devices).
 */
export const authTokenStorage = {
  async get(): Promise<string | null> {
    if (Platform.OS === "web") {
      try {
        return typeof localStorage !== "undefined" ? localStorage.getItem(TOKEN_KEY) : null;
      } catch {
        return null;
      }
    }

    return SecureStore.getItemAsync(TOKEN_KEY);
  },

  async set(token: string): Promise<void> {
    if (Platform.OS === "web") {
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem(TOKEN_KEY, token);
        }
      } catch {
        // Safari private mode or storage disabled — silently no-op.
      }
      return;
    }

    await SecureStore.setItemAsync(TOKEN_KEY, token);
  },

  async remove(): Promise<void> {
    if (Platform.OS === "web") {
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.removeItem(TOKEN_KEY);
        }
      } catch {
        // Safari private mode or storage disabled — silently no-op.
      }
      return;
    }

    await SecureStore.deleteItemAsync(TOKEN_KEY);
  },
};
